import React from "react";
import Content from "../../layouts/Content";
import ContentCarousel from "../contentCarousel/ContentCarousel";
import GoCardless from "./slides/GoCardless";
import Unleashed from "./slides/Unleashed";
import Theme from "../../theme.module.css";
import "./Products.css";


export default function Products({setModalOpen}) {

    const headerSlides = [
        'Unleashed WooCommerce',
        'GoCardless WooCommerce'
    ];

    const contentSlides = [
        <Unleashed setModalOpen={setModalOpen} />,
        <GoCardless />
    ];

    return (
        <section className={`${Theme.section} ${Theme.dark} products`} >
            <h1 className={Theme.sectionTitle}>Products</h1>
            <Content>
                <div style={{display: "flex", justifyContent: "center"}}>
                    <ContentCarousel headerSlides={headerSlides} contentSlides={contentSlides}/>
                </div>
            </Content>
        </section>
    );
}